export const SESSION_STORAGE_BRAND_OBJECT_ID: string = 'brand_object_id'
export const SESSION_STORAGE_BRAND_QUERY_ID: string = 'brand_query_id'
export const TRENDING_BRANDS_REDIS_KEY: string = 'trending_brands'

// eslint-disable-next-line import/no-anonymous-default-export
export default {}
